import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-slate-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yeji0espmi30">
        <div className="text-center" data-id="element-22" data-mp="1aogvee7ke4bs">
          <span className="inline-flex items-center gap-2 rounded-full metal px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-slate-950" data-id="element-23" data-mp="1apidh2mzzr30">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgr57uejs7si" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1eqaqm6yzqg4k">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qydeeermpm2x">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-slate-400/20 bg-slate-800 p-6 shadow-lg shadow-black/20 ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29rbh0wkl17ym" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vrii4dywjlfk">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="20renohn8zkx8">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg metal text-slate-950" data-id="element-30" data-mp="20ptv2xkhuc20">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25oeuwvvu2tpx" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-slate-300" data-id="element-32" data-mp="3c8o56ymtg2vw">Bonus {bonus.number}</p>
                  </div>
                  <p className="whitespace-nowrap text-xs font-bold text-slate-300" data-id="element-33" data-mp="1h2vt2wwvtt38">
                    <span className="line-through" data-id="element-34" data-mp="1c4kkepibpoml">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md metal px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-slate-950" data-id="element-35" data-mp="1c6oksxh0k5i4">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-bold leading-tight text-white" data-id="element-36" data-mp="yce14ujvj1ix">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300" data-id="element-37" data-mp="teck0f60dca3">{bonus.description}</p>

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-38" data-mp="176shl0g54i3m">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-slate-100" data-id="element-39" data-mp="12cegqiiplirk">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-40" data-mp="emtwzxeqehh8" />
                        {item}
                      </li>)}
                  </ul>}

                <div className="flex-1" data-id="element-41" data-mp="5a4ozhqa08qp" />
                <p className="mt-4 rounded-lg border-l-4 border-slate-300 bg-slate-900 px-4 py-3 text-sm font-semibold text-slate-100" data-id="element-42" data-mp="5awj0o485yev">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border border-slate-400/30 bg-slate-950 px-6 py-6 text-center shadow-lg shadow-black/30 sm:flex-row sm:text-left" data-id="element-43" data-mp="ja5lym3f6w0w">
          <div data-id="element-44" data-mp="9byhh2qbi6fs">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-45" data-mp="9chovpicdcfk">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 text-2xl font-extrabold text-slate-400 line-through decoration-red-400 decoration-2" data-id="element-46" data-mp="ecm99qmderb2">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-47" data-mp="2z2bnc1f9292p">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-48" data-mp="3f7wq1h4atgdb">Your price today</p>
            <p className="metal-text mt-1 text-3xl font-extrabold" data-id="element-49" data-mp="3agwt4bv6iyat">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-slate-300" data-id="element-50" data-mp="35htupa9pfqbt">
          Only included in this offer
        </p>
      </div>
    </section>;
}